import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';

import Icon from '@/components/ui/AppIcon';


interface CTABannerProps {
  title: string;
  description: string;
  primaryCTA: {
    text: string;
    link: string;
  };
  secondaryCTA: {
    text: string;
    link: string;
  };
}

const CTABanner = ({ title, description, primaryCTA, secondaryCTA }: CTABannerProps) => {
  const { t } = useLanguage();

  return (
    <section className="py-20 lg:py-28 bg-gradient-gold relative overflow-hidden">
      <div className="relative mx-auto max-w-content px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="w-20 h-20 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon
              name="SparklesIcon"
              size={40}
              className="text-accent"
              variant="solid" />

          </div>

          {/* Title */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6">
            {title}
          </h2>

          {/* Description */}
          <p className="font-body text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed max-w-2xl mx-auto">
            {description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <CTAButton
              href={primaryCTA.link}
              variant="primary"
              className="w-full sm:w-auto min-w-[220px]">

              {primaryCTA.text}
            </CTAButton>
          </div>
        </div>
      </div>
    </section>);

};

export default CTABanner;